import { PortalProps, usePortal } from '@hooks/usePortal'

export function CalendarContainer({ children }: any) {
  const { Portal } = usePortal()

  const props: PortalProps = { children, zIndex: 999 }

  return <Portal {...props} />
}
